import { render, staticRenderFns } from "./invoiceDetails.vue?vue&type=template&id=35c93cd6"
import script from "./invoiceDetails.vue?vue&type=script&lang=js"
export * from "./invoiceDetails.vue?vue&type=script&lang=js"
import style0 from "./invoiceDetails.vue?vue&type=style&index=0&id=35c93cd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports